// Module
var code = "<p>איזה כיף, נשמח לשמוע! אם יש לכם הצעות לשיפור ורעיונות שתרצו לחלוק אתנו, תוכלו להשאיר לנו הודעה בעמוד &quot;צור קשר&quot; שבתחתית האתר. אנחנו נחזור אליכם ונודה לכם באופן אישי.</p> ";
// Exports
export default code;